var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 0C38.2 0 39.98 1.8 39.98 4L40 40L32 32H4C1.8 32 0 30.2 0 28V4C0 1.8 1.8 0 4 0H36ZM9.99993 23.9999H29.9999C31.0999 23.9999 31.9999 23.0999 31.9999 21.9999C31.9999 20.8999 31.0999 19.9999 29.9999 19.9999H9.99993C8.89993 19.9999 7.99993 20.8999 7.99993 21.9999C7.99993 23.0999 8.89993 23.9999 9.99993 23.9999ZM29.9999 18H9.99993C8.89993 18 7.99993 17.1 7.99993 16C7.99993 14.9 8.89993 14 9.99993 14H29.9999C31.0999 14 31.9999 14.9 31.9999 16C31.9999 17.1 31.0999 18 29.9999 18ZM9.99993 11.9999H29.9999C31.0999 11.9999 31.9999 11.0999 31.9999 9.99993C31.9999 8.89993 31.0999 7.99993 29.9999 7.99993H9.99993C8.89993 7.99993 7.99993 8.89993 7.99993 9.99993C7.99993 11.0999 8.89993 11.9999 9.99993 11.9999Z",
    fill: "#555893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewComment);
export default __webpack_public_path__ + "static/media/new_comment.237474a3.svg";
export { ForwardRef as ReactComponent };